import axios from 'axios'

// 创建 axios 实例
const service = axios.create({
  // axios 中请求基地址由 VUE_APP_BASE_API 决定
  baseURL: process.env.VUE_APP_BASE_API || 'http://localhost:8080',
  // 超时
  timeout: 10000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从 localStorage 获取当前语言
    const lang = localStorage.getItem('lang') || 'zh'
    config.headers['Language'] = lang
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    // 如果返回码不是 200，则报错
    if (res.code !== 200) {
      console.error('API Error:', res.msg || 'Error')
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.error('Network Error:', error)
    return Promise.reject(error)
  }
)

export default service
